import type { TourCardStatus, TourDefinition, TourProgressRecord } from '../types';

/**
 * Help-centre status from the saved record: a tour finished at an older version is Updated, one
 * dismissed at an older version is offered as new again.
 */
export function tourCardStatus(
  definition: Pick<TourDefinition, 'version'>,
  record: TourProgressRecord | undefined,
): TourCardStatus {
  if (!record) return 'not-started';
  if (record.version < definition.version) {
    return record.status === 'completed' ? 'updated' : 'not-started';
  }
  return record.status === 'completed' ? 'done' : 'skipped';
}

/** The page's help button carries a "new" dot for these. */
export const isFreshStatus = (status: TourCardStatus) =>
  status === 'not-started' || status === 'updated';
